
/**
 * 運行指示書ページ用のスクリプト
 */

// 一覧
if (is_route('operation_instructionv2.index')) {
    // コンテンツ読み込み後
    $(document).on('bss:onload', function() {
        operation_instruction_event_set();
        operation_instruction_map_set();
    });

    // コンテンツの再読み込み後
    $(document).on('bss:reload', function() {
        operation_instruction_map_set();
    });
}

// 編集
if (is_route('operation_instructionv2.route_search') || is_route('operation_instructionv2.route_master_setting')) {
    // イベントの設定が完了してから処理を開始する
    $(document).on('bss:onload', function() {
        operation_instruction_setting_event_set();
        operation_instruction_setting_map_set();
    });

    // コンテンツの再読み込み後
    $(document).on('bss:reload', function() {
        operation_instruction_setting_map_set();
    });
}

let zMapMain;
let zMapModal;
let polylineLociLatlon = [];
let polylineLoci = false;
let marker = [];
let msg = [];
let RouteData = [];
let elapsed_time_total = 0;
let timerId;
let destination_id = null;

let link_data = [];
let all_flg = false;

let select_route;

var llbox,direction;
var mkrLatLon, dragging, difLat, difLon, pl, latlons, timer=null;
var draggingMarker = null;
var amount=20;

const max_waypoint = 60;

let hasWarningsOnLastClick = false;

/**
 * 一覧ページ読み込み時のイベント設定
 */
window.operation_instruction_event_set = function() {
    let url = new URL(window.location.href);
    $('div.content-wrapper').css('min-height','100%');

    //運行指示書ボタン
    $(document).on('click', '#operation_instruction_btn', function(e) {
        e.preventDefault();
        e.stopPropagation();

        // URLの書き換え（履歴には残さない
        url = new URL(window.location.href);
        url.searchParams.set('mode', 'instruction');
        history.replaceState(null, '', url.pathname + url.search);

        load_contents(null, false);
    });

    //経路マスタボタン
    $(document).on('click', '#route_master_btn', function(e) {
        e.preventDefault();
        e.stopPropagation();

        // URLの書き換え（履歴には残さない
        url = new URL(window.location.href);
        url.searchParams.set('mode', 'route');
        history.replaceState(null, '', url.pathname + url.search);

        load_contents(null, false);
    });

    // 検索用フォーム（内容を変更した際に親formが発火しないように改修
    $(document).on('change','[name=list_range]', function(e) {
        e.preventDefault();
        e.stopPropagation();
    });

    // 検索用フォーム（内容を変更した際に親formが発火しないように改修
    $(document).on('change','.search_text_form', function(e) {
        e.preventDefault();
        e.stopPropagation();
    });

    // 検索用フォーム（内容を変更した際に親formが発火しないように改修
    $(document).on('change','select.search_select_form', function(e) {
        e.preventDefault();
        e.stopPropagation();
    });

    // 各フォームが親formの発火を行わないようにする
    $(document).on('change', '.route_master_parts', function(e){
        e.preventDefault();
        e.stopPropagation();
    });

    // 入力日時（開始）変更時
    $(document).on('change', '#operation_instructionv2-operation_start_date', function () {
        clampEndDateByStartDate();
    });

    // 入力日時（終了）変更時
    $(document).on('change', '#operation_instructionv2-operation_end_date', function () {
        clampStartDateByEndDate();
    });

    // 検索ボタン
    // $(document).on('click','#search-btn', function(e) {
    //     e.preventDefault();
    //     e.stopPropagation();

    //     // URLの書き換え（履歴には残さない
    //     url = new URL(window.location.href);
    //     action = extend_url_query($('#search-form').attr('action'));
    //     $('#search-form').attr('action', action);
    //     history.replaceState(null, '', url.pathname + url.search);

    //     load_contents(null, false);
    // });

    // 編集ボタン（クリックした際に親formが発火しないように改修
    $(document).on('click','.edit_link_btn', function(e) {
        e.stopPropagation();
    });

    // 地図用の要素がリサイズされた場合に地図を表示しなおす
    $(window).on('resize', function(){
        clearTimeout(timerId);
        timerId = setTimeout(() => {
            resizeMap();
        }, 200);
    });

    //印刷ボタン
    $(document).on('click', '[data-print]', function (e) {
        e.preventDefault();
        e.stopPropagation();

        // 送信値を配列化
        let datas = [];
        let action = extend_url_query($(this).data('print'));
        // BlobでPDFを別ウィンドウで表示
        _ajax.blob(action, datas, function (blob) {
            window.open(window.URL.createObjectURL(blob), '_blank');
        }, function(xhr, status, errorThrown){
            _error.omitted(xhr, status, errorThrown);
        });
    });

    $(document).on('click', '#instruction-tab', function (e) {
        url = new URL(window.location.href);
        url.searchParams.set('mode', 'instruction');
        history.replaceState(null, '', url.pathname + url.search);
    });

    $(document).on('click', '#route_master-tab', function (e) {
        url = new URL(window.location.href);
        url.searchParams.set('mode', 'route');
        history.replaceState(null, '', url.pathname + url.search);
    });
}

window.operation_instruction_map_set = function() {
    //map
    zMapMain = $('#instruction_map').find('.video-map');

    // 初期データ
    RouteData = $('#instruction_map').find('.video-map').data('route_data');

    // 地図：初期表示
    setTimeout(function(){
        createMap();
        deleteRouteData();
        drawRouteData();
        adjustMapZoom();
    },1000);

    //一覧のデータをクリック時に地図上の経路データを書き換える
    $(document).off("click", ".instruction_data");
    $(document).on('click', '.instruction_data', function() {
        $('.highlight').removeClass('highlight');
        $(this).addClass('highlight');
        RouteData = $(this).data('route_data');
        link_data = $(this).data('link_data');
        marker_move_flg = false;
        deleteRouteData();
        drawDirectionRouteData(marker_move_flg);
        adjustMapZoom();
    });

    setViolationIcon('tr.instruction_data');
}


/**
 * 編集ページ読み込み時のイベント設定
 */
window.operation_instruction_setting_event_set = function() {
    $('div.content-wrapper').css('min-height','100%');

    setDatePickerForStartTime();

    // 各フォームが親formの発火を行わないようにする
    $(document).on('click', '.instruction_parts', function(e){
        e.preventDefault();
        e.stopPropagation();
    });

    // 各フォームが親formの発火を行わないようにする
    $(document).on('change', '#search-form-passenger', function(e){
        e.preventDefault();
        e.stopPropagation();
    });


    // 検索用フォーム（内容を変更した際に親formが発火しないように改修
    $(document).on('change','.search_text_form', function(e) {
        e.preventDefault();
        e.stopPropagation();
    });

    // データの変更が行われたらフラグを立てる
    let changedFlg = false;
    $(document).on('change', '.form_parts', function(e){
        changedFlg = true;
    });

    // 戻るボタン
    $(document).on('click', '#operation_instruction-revise_route', function(e) {
        e.preventDefault();
        e.stopPropagation();
        if(changedFlg) {
            if (!confirm('変更が保存されておりませんが\n一覧に戻りますか？')) {
                return false;
            } else {
                window.location.href = $(this).data('url');
            }
        } else {
            window.location.href = $(this).data('url');
        }
    });

    $(document).on('click', '.fixed_date', function(e){
        // 親要素へのクリックイベント伝搬を回避する
        //e.preventDefault();
        //e.stopPropagation();
    });

    // 地図用の要素がリサイズされた場合に地図を表示しなおす
    $(window).on('resize', function(){
        clearTimeout(timerId);
        timerId = setTimeout(() => {
            resizeMap();
        }, 200);
    });

    setViolationIcon('tr.route_data_record');

}

window.operation_instruction_setting_map_set = function() {
    // 地点の数
    let way_point_index = 0;
    let insert_number = 0;

    // 検索用のマーカー
    let search_marker;

    //map
    zMapMain = $('#instruction_map').find('.video-map');

    // 経路データ
    RouteData = $('#instruction_map').find('.video-map').data('route_data');

    // 経路の線データ
    link_data = $('#instruction_map').data('link_data');

    // 地図用の要素がリサイズされた場合に地図を表示しなおす
    $(window).on('resize', function(){
        clearTimeout(timerId);
        timerId = setTimeout(() => {
            adjustMapZoom();
        }, 200);
    });

    //　住所検索
    $(document).on('click', '.search_address', function(){
        let val = $('.search_map_text').val();
        destination_id = null;
        // 入力なしは何もしない
        if (val.length === 0) {
            return;
        }
        // OAuthパラメタ取得
        let apiName = 'address/word';
        let data = {
            api: apiName,
            word: val,
            limit: 1
        };

        _ajax.post(_zdcMap._mapApiUrl, data, function (result) {
            ZDC.Search.getByZmaps(apiName, result.params, function (status, res) {
                if (status.code === 200 && res.info.hit > 0) {
                    if(search_marker) {
                        _zdcMap._zMap.removeWidget(search_marker);
                    }
                    _zdcMap._zMap.moveLatLon(new ZDC.LatLon(res.item[0].point.lat, res.item[0].point.lon));
                    search_marker = new ZDC.Marker(
                        new ZDC.LatLon(res.item[0].point.lat, res.item[0].point.lon),
                        {
                            color: ZDC.MARKER_COLOR_ID_GREEN_L,
                        }
                    );
                    _zdcMap._zMap.addWidget(search_marker);
                    ZDC.addListener(search_marker, ZDC.MARKER_MOUSEMOVE, (function(mrk) {
                        return function() {
                            onMarkerMouseMove(mrk);
                        };
                    })(search_marker));
                    ZDC.addListener(search_marker, ZDC.MARKER_MOUSEDOWN, (function(mrk) {
                        return function() {
                            mkrLatLon = mrk.getLatLon();
                            onMarkerMouseDown(mrk);
                        };
                    })(search_marker));
                    ZDC.addListener(search_marker, ZDC.MARKER_MOUSEUP, (function(way_point_index) {
                        return function() {
                            onMarkerMouseUp();
                        };
                    })(way_point_index));
                } else if(res.info.hit <= 0) {
                    toastr.warning('住所からの地点取得ができませんでした。入力内容を再度確認してください');
                }
                $('.add_start_place').prop('disabled', false);
                $('.add_waypoint').prop('disabled', false);
            });
        }, function (xhr, status, errorThrown) {
            _error.omitted(xhr, status, errorThrown);
        });
    });

    // 行先マスタから検索
    $(document).on('click', '#operation_instruction-search_master', function(){
        let action = $(this).data('action');
        let select_name = $('[name="search_map_text"]').val();
        destination_id = null;

        if(select_name.length > 0) {
            datas = {
                _token: $('meta[name="csrf-token"]').attr('content'),
                name: $('[name="search_map_text"]').val(),
                holding_id:$('#user-holding-config').children('span').data('replace-name-holding-id'),
                company_id:$('#user-company-config').children('span').data('replace-name-company-id'),
            };

            _ajax.post(action, datas, function(res) {
                if(res.count == 1) {
                    if(search_marker) {
                        _zdcMap._zMap.removeWidget(search_marker);
                    }
                    _zdcMap._zMap.moveLatLon(new ZDC.LatLon(res.latitude, res.longitude));
                    search_marker = new ZDC.Marker(
                        new ZDC.LatLon(res.latitude, res.longitude),
                        {
                            color: ZDC.MARKER_COLOR_ID_GREEN_L,
                        }
                    );
                    destination_id = res.destination_id;
                    _zdcMap._zMap.addWidget(search_marker);
                    ZDC.addListener(search_marker, ZDC.MARKER_MOUSEMOVE, (function(mrk) {
                        return function() {
                            onMarkerMouseMove(mrk);
                        };
                    })(search_marker));
                    ZDC.addListener(search_marker, ZDC.MARKER_MOUSEDOWN, (function(mrk) {
                        return function() {
                            mkrLatLon = mrk.getLatLon();
                            onMarkerMouseDown(mrk);
                        };
                    })(search_marker));
                    ZDC.addListener(search_marker, ZDC.MARKER_MOUSEUP, (function(way_point_index) {
                        return function() {
                            onMarkerMouseUp();
                        };
                    })(way_point_index));
                    $('.add_start_place').prop('disabled', false);
                    $('.add_waypoint').prop('disabled', false);
                } else {
                    $('#select-destination-modal div.modal-content').html(res.destination_list_view);
                    _modal.show('#select-destination-modal');
                }
            },function(xhr, status, errorThrown){
                let responseText = JSON.parse(xhr.responseText);
                toastr.warning(responseText.text);
            });
        }
    });

    $(document).on('click', 'button.destinaion_select-btn', function(){
        if(search_marker) {
            _zdcMap._zMap.removeWidget(search_marker);
        }
        _zdcMap._zMap.moveLatLon(new ZDC.LatLon($(this).data('latitude'), $(this).data('longitude')));
        search_marker = new ZDC.Marker(
            new ZDC.LatLon($(this).data('latitude'), $(this).data('longitude')),
            {
                color: ZDC.MARKER_COLOR_ID_GREEN_L,
            }
        );
        destination_id = $(this).data('destination_id');
        _zdcMap._zMap.addWidget(search_marker);
        ZDC.addListener(search_marker, ZDC.MARKER_MOUSEMOVE, (function(mrk) {
            return function() {
                onMarkerMouseMove(mrk);
            };
        })(search_marker));
        ZDC.addListener(search_marker, ZDC.MARKER_MOUSEDOWN, (function(mrk) {
            return function() {
                mkrLatLon = mrk.getLatLon();
                onMarkerMouseDown(mrk);
            };
        })(search_marker));
        ZDC.addListener(search_marker, ZDC.MARKER_MOUSEUP, (function(way_point_index) {
            return function() {
                onMarkerMouseUp();
            };
        })(way_point_index));
        $('.add_start_place').prop('disabled', false);
        $('.add_waypoint').prop('disabled', false);
        _modal.hide('#select-destination-modal');
    });

    // 住所用入力用テキストフォーム(エンター時に住所検索が発動するように設定)
    $(document).on('keydown', 'input#operation_instruction-search_map_text', function(e){
        if (e.key === 'Enter') {
            e.preventDefault();
            $('#operation_instruction-search_address').trigger('click'); // 紐づけたいボタン
            return false;
        }
    });

    //出発地の追加
    $(document).on('click', '.add_start_place', function(e){
        if(search_marker) {
            let LatLon = search_marker.getLatLon();
            let blank_tr = $('.blank_tr').clone();

            blank_tr.find('tr').data('lat', LatLon['lat']);
            blank_tr.find('tr').data('lon', LatLon['lon']);
            blank_tr.find('.instruction_number').text(way_point_index+1);

            blank_tr.find('[name="start_time[]"]').attr('name','start_time['+way_point_index+']')
            .attr('id','start_time_'+way_point_index);

            blank_tr.find('[name="fixed_date[]"]').attr('name','fixed_date['+way_point_index+']')
            .attr('id','fixed_date_'+way_point_index);

            blank_tr.find('.work_type_box').empty().text('出発地');
            blank_tr.find('.elapsed_time_box').remove();
            blank_tr.find('.run_time_box').remove();

            blank_tr.find('[name="place_name[]"]').val($('[name="search_map_text"]').val())
            .attr('name','place_name['+way_point_index+']')
            .attr('id','place_name_'+way_point_index);

            blank_tr.find('.add_button').data('number',way_point_index);
            blank_tr.find('.add_button').attr('data-number',way_point_index);
            blank_tr.find('.delete_button').remove();

            $('.instruction_list tbody').append(blank_tr.removeClass('blank_tr').addClass('route_data_record replaceable'));
            $('.point_search_box').addClass('d-none');
            $(this).addClass('d-none');
            $('.add_waypoint').removeClass('d-none');

            initStartTimePicker(blank_tr.find('input.start_time_form'));

            RouteData[way_point_index] = {
                latitude: LatLon['lat'],
                longitude: LatLon['lon'],
                destination_id: null,
                place_name: $('[name="search_map_text"]').val(),
                work_time: null,
                work_type: 0,
                route_type: 'STR',
                time3: 0
            };
            way_point_index++;
            let total_time = 0;
            let start_time = 0;
            createMarker(start_time,total_time);

            _zdcMap._zMap.removeWidget(search_marker);
            $('.add_start_place').prop('disabled', true);
            $('.add_waypoint').prop('disabled', true);
            if($('#operation_instruction_instruction-submit').length) {
                $('#operation_instruction_instruction-submit').prop('disabled', false);
            }
            if($('#operation_instruction_route_master-submit').length) {
                $('#operation_instruction_route_master-submit').prop('disabled', false);
            }
        }
    });

    // 経由地or到着地の追加
    $(document).on('click', '.add_waypoint', function(){
        if(search_marker) {
            let route_data = [];
            let from;
            let to;
            let action = $(this).data('url');
            let datas = [];
            let mpoints = [];
            let LatLon = search_marker.getLatLon();
            let previousLatLon = marker[insert_number].getLatLon();

            //選択した住所と一つ前の地点の緯度経度が異なるなら経路取得処理を行う
            if(LatLon['lat'] != previousLatLon['lat'] || LatLon['lon'] != previousLatLon['lon']) {
                let move_attached_flg = true;
                $.each(RouteData, function(num, item){
                    if(item.route_type == 'ICI') {
                        move_attached_flg = false;
                    } else if(item.route_type == 'ICO') {
                        move_attached_flg = true;
                    }
                    if(num==0) {
                        route_data.push(item);
                    } else if(num==RouteData.length-1){
                        route_data.push(item);
                    } else {
                        if(item.route_type != 'BRG' && item.route_type != 'BRH' ) {
                            if(item.work_type != null && move_attached_flg) {
                                route_data.push(item);
                            }
                        }
                    }
                });

                route_data.splice(insert_number+1, 0, {
                    latitude: LatLon['lat'],
                    longitude: LatLon['lon'],
                    destination_id: destination_id,
                    place_name: $('[name="search_map_text"]').val(),
                    work_time: null,
                    work_type: 0,
                    route_type: 'VIA',
                    type: 'office'
                });

                $.each(route_data, function(num, item){
                    if(num==0) {
                        from = new ZDC.LatLon(item.latitude, item.longitude);
                    } else if(num==route_data.length-1){
                        to = new ZDC.LatLon(item.latitude, item.longitude);
                    } else {
                        mpoints.push(item.latitude);
                        mpoints.push(item.longitude);
                    }
                });

                datas = {
                    from_code: from.lat + ',' + from.lon,
                    to_code: to.lat + ',' + to.lon,
                    _token: $('meta[name="csrf-token"]').attr('content'),
                    route_data: route_data,
                    insert_num: insert_number,
                    start_time: $('[name="start_time[0]"]').val(),
                    replaceable_num: $('table.instruction_list tbody tr.replaceable').length,
                    type : $(this).data('type')
                };

                if(mpoints.length > 0) {
                    datas['mpoints'] = mpoints.join(',');
                }

                _ajax.post(action, datas, function(results) {
                    deleteRouteData();

                    let resultParse = JSON.parse(results);
                    link_data = resultParse.route;
                    link_data.forEach(link =>{
                        for (var k=0, l=link.line.latlon.length; k<l; k+=2) {
                            polylineLociLatlon.push(new ZDC.LatLon(String(link.line.latlon[k]),String(link.line.latlon[k+1])));
                        }
                    });
                    polylineLoci = new ZDC.Polyline(
                        polylineLociLatlon,
                        {
                            strokeColor: '#669DF6',
                            strokeWeight: 3,
                            closePath: false,
                        }
                    );
                    _zdcMap._zMap.addWidget(polylineLoci);
                    RouteData = resultParse.route_list;

                    let prev_row = $('table.instruction_list tbody tr.replaceable').eq(insert_number);
                    let targets_row = prev_row.nextUntil('tr.replaceable');
                    targets_row.remove();

                    let $html = $(resultParse.route_list_view);
                    prev_row.after($html);
                    initStartTimePicker($html.find('input.start_time_form'));

                    // 追加ボタンが押された地点が到着地点だったら作業用セレクトボックスを追加する
                    let workCell = prev_row.find('td.work_type_cell');
                    if (insert_number != 0 && workCell.find('select').length === 0) {
                        let blank_tr = $('.blank_tr').clone();
                        workCell.html(blank_tr.find('select'));
                    }

                    renumberInstructionDetail();
                    setDateTime(prev_row,'run');

                    let total_time = 0;
                    let start_time =  convertStringToTime(prev_row.find('input.start_time_form').val());
                    createMarker(start_time,total_time);

                    $('.point_search_box').addClass('d-none');
                    way_point_index++;
                    setPlanData();
                    if(search_marker) {
                        _zdcMap._zMap.removeWidget(search_marker);
                    }
                    $('.add_start_place').prop('disabled', true);
                    $('.add_waypoint').prop('disabled', true);
                },function(xhr, status, errorThrown){
                    let responseText = JSON.parse(xhr.responseText);
                    toastr.warning(responseText.responseText);
                },'html');
            } else {
                toastr.warning('同一住所が連続で指定されています');
            }
        }
    });

    // 追加ボタン
    $(document).on('click', '.add_button', function(){
        if($('tr.replaceable').length < max_waypoint) {
            insert_number = $(this).data('number');
            select_tr = $(this).parents('.route_data_record');
            $('[name="search_map_text"]').val('');
            $('.point_search_box').removeClass('d-none');
        } else {
            toastr.warning('経由地は'+max_waypoint+'個以内にしてください');
        }
    });

    // 経路ごとの削除ボタン
    $(document).on('click', '.delete_button', function(){
        insert_number = $(this).data('number');
        let replaceable_num = $('table.instruction_list tbody tr.replaceable').length-1;
        let last_flg = false;
        row_index = $(this).closest('tr').index();
        select_tr = $(this).closest('.route_data_record');
        insert_number--;
        if(insert_number == replaceable_num) {
            route_data_record = $(this).closest('tr.route_data_record');
            select_tr = route_data_record.prevAll('tr.replaceable').first();
            last_flg = true;
        }

        let route_data = [];

        let from;
        let to;
        let action = $('.add_waypoint').data('url');
        let datas = [];
        let mpoints = [];

        let move_attached_flg = true;
        $.each(RouteData, function(num, item){
            if(num != row_index) {
                if(item.route_type == 'ICI') {
                    move_attached_flg = false;
                } else if(item.route_type == 'ICO') {
                    move_attached_flg = true;
                }
                if(num==0) {
                    route_data.push(item);
                } else if(num==RouteData.length-1){
                    route_data.push(item);
                } else {
                    if(item.route_type != 'BRG' && item.route_type != 'BRH' ) {
                        if(item.work_type != null && move_attached_flg) {
                            route_data.push(item);
                        }
                    }
                }
            }
        });

        if(route_data.length > 1) {

            $.each(route_data, function(num, item){
                if(num==0) {
                    from = new ZDC.LatLon(item.latitude, item.longitude);
                } else if(num==route_data.length-1){
                    to = new ZDC.LatLon(item.latitude, item.longitude);
                } else {
                    mpoints.push(item.latitude);
                    mpoints.push(item.longitude);
                }
            });

            datas = {
                from_code: from.lat + ',' + from.lon,
                to_code: to.lat + ',' + to.lon,
                _token: $('meta[name="csrf-token"]').attr('content'),
                route_data: route_data,
                insert_num: insert_number,
                start_time: $('[name="start_time[0]"]').val(),
                replaceable_num: replaceable_num,
            };


            if(mpoints.length > 0) {
                datas['mpoints'] = mpoints.join(',');
            }

            _ajax.post(action, datas, function(results) {
                deleteRouteData();
                let resultParse = JSON.parse(results);
                link_data = resultParse.route;

                RouteData = resultParse.route_list;
                drawDirectionRouteData();

                let prev = select_tr.prevAll('tr.replaceable').first();
                let next = select_tr.nextAll('tr.replaceable').first();
                let targets_row = prev.nextUntil(next);
                targets_row.remove();

                let insert_data = $(resultParse.route_list_view).filter('tr');
                if(last_flg) {
                    route_data_record.remove();
                } else {
                    let target = insert_data.filter('.replaceable').last();
                    insert_data = insert_data.not(target);
                }

                prev.after(insert_data);
                initStartTimePicker(insert_data.find('input.start_time_form'));

                renumberInstructionDetail();
                setDateTime(prev,'run');

                $('.point_search_box').addClass('d-none');
                way_point_index = RouteData.length;
                setPlanData();
            },function(xhr, status, errorThrown){
                let responseText = JSON.parse(xhr.responseText);
                toastr.warning(responseText.responseText);
            },'html');
        } else {
            RouteData = route_data;
            link_data = {};
            setPlanData();
            deleteRouteData();
            drawDirectionRouteData();
            let prev = select_tr.prevAll('tr.replaceable').first();
            let next = select_tr.nextAll('tr.replaceable').first();
            let targets_row = prev.nextUntil(next);
            targets_row.remove();
        }
    });

    $(document).on('keydown', '#operation_instruction-form input[type="text"]', function(e) {
        if (e.key === 'Enter') {
            e.preventDefault();
            $(this).trigger('change');
        }
    });

    //日時
    $(document).on('change', 'input.start_time_form', function(){

        if($(this).val().length <= 0) {
            const now = new Date();
            now.setMinutes(now.getMinutes() - now.getTimezoneOffset());
            const formatDate = now.toISOString().slice(0, 16);
            $(this).val(formatDate);
        }

        let tr = $(this).closest('tr.route_data_record');
        setDateTime(tr,'start');

        let total_time = 0;
        let start_time =  convertStringToTime($(this).val());
        createMarker(start_time,total_time);
    });

    //所要時間（走行時間）
    $(document).on('change', 'input.run_time_form', function(){
        let tr = $(this).closest('tr.route_data_record');
        let index = tr.find('td.instruction_number_cell').text()-1;
        setDateTime(tr, 'run');

        let total_time = 0;
        let start_time = 0;
        if (tr.find('input.start_time_form').length === 0){
            start_time = convertStringToTime(tr.find('.start_time_box').text());
        } else {
            start_time = convertStringToTime(tr.find('input.start_time_form').val());
        }
        if (RouteData[index]) {
            RouteData[index]['run_data']['elapsed_time'] = parseInt($(this).val(), 10);
            RouteData[index]['run_data']['time3'] = parseInt($(this).val(), 10);
        }
        createMarker(start_time,total_time);
        setPlanData();
    });

    //作業時間
    $(document).on('change', 'input.elapsed_time_form', function(){
        let tr = $(this).closest('tr.route_data_record');
        let index = tr.find('td.instruction_number_cell').text()-1;
        setDateTime(tr,'elapsed');

        let total_time = 0;
        let start_time = 0;
        if (tr.find('input.start_time_form').length === 0){
            start_time = convertStringToTime(tr.find('.start_time_box').text());
        } else {
            start_time = convertStringToTime(tr.find('input.start_time_form').val());
        }
        if (RouteData[index]) {
            RouteData[index]['elapsed_time'] = parseInt($(this).val(), 10);
            RouteData[index]['time3'] = parseInt($(this).val(), 10);
        }
        createMarker(start_time,total_time);
        setPlanData();
    });

    // 作業
    $(document).on('change', 'select.work_type_form', function(){
        let tr = $(this).closest('tr.route_data_record');
        let index = tr.find('td.instruction_number_cell').text()-1;
        if(RouteData[index]) {
            RouteData[index]['work_type'] = $(this).val();
        }
        setPlanData();
    });

    //作業地
    $(document).on('change', '#place_name[0]', function(){
        $('.plan_start_place').text($(this).val());
    });

    // 運行指示書作成ボタン
    $(document).on('click', '#operation_instruction_instruction-submit', function(e){
        // 親要素へのクリックイベント伝搬を回避する
        e.preventDefault();
        e.stopPropagation();

        if(RouteData.length > 0) {
            const hasWarningsNow = checkRouteData();
            if (!hasWarningsNow) {
                hasWarningsOnLastClick = false;
            } else if (!hasWarningsOnLastClick) {

                let msgs = [];
                $('tr.route_data_record').each(function() {
                    const raw = $(this).attr('data-warning-messages');
                    if (!raw) return;

                    try {
                        msgs = msgs.concat(JSON.parse(raw));
                    } catch (_) {}
                });

                // if (msgs.length) {
                //     alert(msgs.join('\n'));
                // }
                //alert('違反項目があります');

                // 違反あり 1回目(保存させない)
                hasWarningsOnLastClick = true;
                _modal.show('#violation_warning-modal');
                return false;
            } else {
                //違反あり 2回目(confirmではいを選んだら保存)
                const ok = confirm('違反項目がありますが、\nこのまま保存しますか？');
                if (!ok) {
                    return false;
                }
            }

            // 保存処理へデータ送信
            let action = extend_url_query($('#operation_instruction-form').data('action'));

            // route_master_flgを削除
            let url = new URL(action, location.origin);
            url.searchParams.delete('route_master_flg');
            action = url.pathname + url.search;

            let record_id = $('#operation_instruction-id').val();

            let route_list_temp = RouteData;
            setEditRouteData();
            let precaution_flg = {};

            $('input[type="checkbox"][name^="precaution_flg"]:checked').each(function() {
                let val = this.value;
                precaution_flg[val] = $(this).data('content');
            });

            let start_time = $('table.instruction_list').find('input.start_time_form').first().val();
            let end_time = $('table.instruction_list').find('input.start_time_form').last().val();

            // 検索フォームを配列化
            let datas = {
                id: record_id,
                holding_id: $('#user-holding-config').children('span').data('replace-name-holding-id'),
                company_id: $('#user-company-config').children('span').data('replace-name-company-id'),
                section_id: $('#user-section-config').children('span').data('replace-name-section-id'),
                vehicle: $('#search-form-vehicle').val(),
                driver: $('#search-form-driver').val(),
                passenger: $('#search-form-passenger').val(),
                route_list: JSON.stringify(RouteData),
                link_data: JSON.stringify(link_data),
                precaution_flg: precaution_flg,
                start_time: start_time,
                end_time: end_time,
                _token: $('meta[name="csrf-token"]').attr('content'),
            };

            // ポスト送信を実行
            _ajax.post(action, datas, function(response) {
                window.location.href = response.return_url;
            }, function(xhr, status, errorThrown){
                if (xhr.status === 409) {
                    const res = xhr.responseJSON;
                    toastr.warning(res.return_text);
                    return;
                }
                RouteData = route_list_temp;
                let selector = '#search-form';
                _error.set(selector, xhr, status, errorThrown);
                //_error.omitted(xhr, status, errorThrown);
            });
        } else {
            toastr.warning('経路情報がないため登録できません。経路情報を設定して保存してください');
        }
    });

    // 経路マスタ編集ページ用作成ボタン
    $(document).on('click', '#operation_instruction_route_master-submit', function(e){
        // 親要素へのクリックイベント伝搬を回避する
        e.preventDefault();
        e.stopPropagation();

        if(RouteData.length > 0) {
            const hasWarningsNow = checkRouteData();

            if (!hasWarningsNow) {
                hasWarningsOnLastClick = false;
            } else if (!hasWarningsOnLastClick) {

                let msgs = [];
                $('tr.route_data_record').each(function() {
                    const raw = $(this).attr('data-warning-messages');
                    if (!raw) return;

                    try {
                        msgs = msgs.concat(JSON.parse(raw));
                    } catch (_) {}
                });

                // if (msgs.length) {
                //     alert(msgs.join('\n'));
                // }
                //alert('違反項目があります');

                // 違反あり 1回目(保存させない)
                hasWarningsOnLastClick = true;
                _modal.show('#violation_warning-modal');
                return false;
            } else {
                //違反あり 2回目(confirmではいを選んだら保存)
                const ok = confirm('違反項目がありますが、\nこのまま保存しますか？');
                if (!ok) {
                    return false;
                }
            }

            $('#route_master_name').val($('#operation_instruction-text-name').val());
            _modal.show('#create-route-master-modal');

        } else {
            toastr.warning('経路情報がないため登録できません。経路情報を設定して保存してください');
        }
    });

    // 経路マスタ編集ページモーダル内の作成ボタン
    $(document).on('click', '#create_route_master_modal_btn', function(e){
        // 親要素へのクリックイベント伝搬を回避する
        e.preventDefault();
        e.stopPropagation();
        let route_master_name = $('#route_master_name').val();
        if(route_master_name.length <= 0) {
            $('#route_master_name-errors span').text('経路マスタ名は必須です');
            $('#route_master_name-errors span').show();
        } else {
            $('#route_master_name-errors span').text('');
            $('#route_master_name-errors span').hide();
            // 保存処理へデータ送信
            let action = extend_url_query($('#operation_instruction-form').data('action'));
            let record_id = $('#operation_instruction-id').val();

            let route_list_temp = RouteData;
            setEditRouteData();
            let precaution_flg = {};

            $('input[type="checkbox"][name^="precaution_flg"]:checked').each(function() {
                let val = this.value;
                precaution_flg[val] = $(this).data('content');
            });

            // 検索フォームを配列化
            let datas = {
                id: record_id,
                holding_id: $('#user-holding-config').children('span').data('replace-name-holding-id'),
                company_id: $('#user-company-config').children('span').data('replace-name-company-id'),
                section_id: $('#user-section-config').children('span').data('replace-name-section-id'),
                name: route_master_name,
                route_list: JSON.stringify(RouteData),
                link_data: JSON.stringify(link_data),
                precaution_flg: precaution_flg,
                _token: $('meta[name="csrf-token"]').attr('content'),
                route_master_flg: true
            };

            // ポスト送信を実行
            _ajax.post(action, datas, function(response) {
                window.location.href = response.return_url;
            }, function(xhr, status, errorThrown){
                if (xhr.status === 409) {
                    const res = xhr.responseJSON;
                    toastr.warning(res.return_text);
                    return;
                }
                RouteData = route_list_temp;
                let selector = '#search-form';
                _error.set(selector, xhr, status, errorThrown);
                //_error.omitted(xhr, status, errorThrown);
            });
        }
    });

    // 運行指示書編集ページ用経路マスタ作成ボタン
    $(document).on('click', '#operation_instruction_master-submit', function(e){
        // 親要素へのクリックイベント伝搬を回避する
        e.preventDefault();
        e.stopPropagation();
        $('#route_master_name').val($('#operation_instruction-text-name').val());
        _modal.show('#create-route-master-modal');
    });

    // 運行指示書編集ページ内の経路マスタ作成ボタン
    $(document).on('click', '#instruction_route_master_modal_btn', function(e){
        // 親要素へのクリックイベント伝搬を回避する
        e.preventDefault();
        e.stopPropagation();

        let route_master_name = $('#route_master_name').val();
        if(route_master_name.length <= 0) {
            $('#route_master_name-errors span').text('経路マスタ名は必須です');
            $('#route_master_name-errors span').show();
        } else {
            $('#route_master_name-errors span').text('');
            $('#route_master_name-errors span').hide();
            const hasWarningsNow = checkRouteData();

            if (!hasWarningsNow) {
                hasWarningsOnLastClick = false;
            } else if (!hasWarningsOnLastClick) {

                let msgs = [];
                $('tr.route_data_record').each(function() {
                    const raw = $(this).attr('data-warning-messages');
                    if (!raw) return;

                    try {
                        msgs = msgs.concat(JSON.parse(raw));
                    } catch (_) {}
                });

                // if (msgs.length) {
                //     alert(msgs.join('\n'));
                // }
                //alert('違反項目があります');

                // 違反あり 1回目(保存させない)
                hasWarningsOnLastClick = true;
                return false;
            } else {
                //違反あり 2回目(confirmではいを選んだら保存)
                const ok = confirm('違反項目がありますが、\nこのまま保存しますか？');
                if (!ok) {
                    return false;
                }
            }

            // 保存処理へデータ送信
            // アクションの取得
            let action = extend_url_query($('#operation_instruction-form').data('action'));
            let record_id = $('#operation_instruction-id').val();

            let route_list_temp = RouteData;
            setEditRouteData();
            let precaution_flg = {};

            $('input[type="checkbox"][name^="precaution_flg"]:checked').each(function() {
                let val = this.value;
                precaution_flg[val] = $(this).data('content');
            });

            let start_time = $('table.instruction_list').find('input.start_time_form').first().val();
            let end_time = $('table.instruction_list').find('input.start_time_form').last().val();

            // 検索フォームを配列化
            let datas = {
                instrcution_id: record_id,
                holding_id:$('#user-holding-config').children('span').data('replace-name-holding-id'),
                company_id:$('#user-company-config').children('span').data('replace-name-company-id'),
                section_id:$('#user-section-config').children('span').data('replace-name-section-id'),
                name: route_master_name,
                vehicle: $('#search-form-vehicle').val(),
                driver: $('#search-form-driver').val(),
                passenger: $('#search-form-passenger').val(),
                route_list: JSON.stringify(RouteData),
                link_data: JSON.stringify(link_data),
                precaution_flg: precaution_flg,
                start_time: start_time,
                end_time: end_time,
                _token: $('meta[name="csrf-token"]').attr('content'),
                route_master_flg: true,
                instruction_flg:true
            };

            // ポスト送信を実行
            _ajax.post(action, datas, function(response) {
                window.location.href = response.return_url;
            }, function(xhr, status, errorThrown){
                RouteData = route_list_temp;
                let selector = '#search-form';
                _error.set(selector, xhr, status, errorThrown);
               // _error.omitted(xhr, status, errorThrown);
            });
        }
    });
    $(document).on('click', '#operation_instruction-delete_btn', function(e) {
        e.preventDefault();
        e.stopPropagation();
        _modal.show('#operation_instruction_delete-modal');
    });

    // 削除ボタン
    $(document).on('click', '#operation_insctruction-delete_modal-btn', function(e) {
        e.preventDefault();
        e.stopPropagation();
        let action = $('#operation_instruction-delete_btn').data('url');
        // ポスト送信を実行（削除）削除処理を作ったら修正
        let datas ={
            id: $('#operation_instruction-id').val(),
            token:$('meta[name="csrf-token"]').attr('content'),
            holding_id:$('#user-holding-config').children('span').data('replace-name-holding-id'),
            company_id:$('#user-company-config').children('span').data('replace-name-company-id'),
            section_id:$('#user-section-config').children('span').data('replace-name-section-id'),
        }
        _ajax.post(action, datas, function(response) {
            window.location.href = response.return_url;
        }, function(xhr, status, errorThrown){
            _error.omitted(xhr, status, errorThrown);
        });
    });

    // 地図：初期表示
    setTimeout(function(){
        createMap();
        if(link_data) {
            drawDirectionRouteData();
        }
        adjustMapZoom();
    },1000);

    // 戻るボタン
    $(document).on('click', '#operation_instruction-revise_route', function(e) {
        e.preventDefault();
        e.stopPropagation();
        window.location.href = $(this).data('url');
    });

    //経路マスタ選択ボタンクリック（モーダル表示）
    $(document).on('click','#operation_instruction-select_route_master', function(e) {
        e.preventDefault();
        e.stopPropagation();
        _modal.create(this, 'modal', ['holding_id', 'company_id', 'section_id']);
    });

    //モーダル内、一覧のデータをクリック時に地図上の経路データを書き換える
    $(document).off("click", ".route_search_data");
    $(document).on('click', '.route_search_data', function(e) {
        e.preventDefault();
        e.stopPropagation();

        select_route = $(this);
        $('.highlight').removeClass('highlight');
        $(this).addClass('highlight');
        RouteData = $(this).data('route_data');
        link_data = $(this).data('link_data');
        deleteRouteData();
        drawDirectionRouteData();
        adjustMapZoom();
        $('#outward_trip-btn').prop('disabled', false);
        $('#outward_trip-btn').removeAttr('style')
        $('#return_trip-btn').prop('disabled', false);
        $('#return_trip-btn').removeAttr('style')
    });

    //往路に設定
    $(document).on('click', '#outward_trip-btn', function() {
        if(select_route.length > 0) {
            $('.outward_trip-input').data('outward_trip_id',select_route.data('id'));
            $('.outward_trip-input').val(select_route.find('.route_name').text().trim());
        }
    });

    //復路に設定
    $(document).on('click', '#return_trip-btn', function() {
        if(select_route.length > 0) {
            $('.return_trip-input').data('return_trip_id',select_route.data('id'));
            $('.return_trip-input').val(select_route.find('.route_name').text().trim());
        }
    });

    //経路マスタ選択内の検索ボタン
    $(document).on('click', '#search_route-btn', function() {
        let action = $(this).data('url');
        let datas = {
            _token: $('meta[name="csrf-token"]').attr('content'),
            route_name: $('input[name="route_name"]').val(),
            start_place_name: $('input[name="start_place_name"]').val(),
            end_place_name: $('input[name="end_place_name"]').val(),
            holding_id:$('#user-holding-config').children('span').data('replace-name-holding-id'),
            company_id:$('#user-company-config').children('span').data('replace-name-company-id'),
            section_id:$('#user-section-config').children('span').data('replace-name-section-id'),
        };
        _ajax.post(action, datas, function(results) {
            $('.route_search_box').html($(results.route_list_view));
        }
        ,function(xhr, status, errorThrown){
            let responseText = JSON.parse(xhr.responseText);
            toastr.warning(responseText.text);
        });
    });

    // 経路マスタ選択モーダル内のページネーション
    $(document).on('click', '.route_select_modal_pagination a', function(e) {
        e.preventDefault();

        let action = $(this).attr('href');
        let datas = {
            _token: $('meta[name="csrf-token"]').attr('content'),
            route_name: $('input[name="hidden_route_name"]').val(),
            start_place_name: $('input[name="shidden_tart_place_name"]').val(),
            end_place_name: $('input[name="hidden_end_place_name"]').val(),
            holding_id:$('#user-holding-config').children('span').data('replace-name-holding-id'),
            company_id:$('#user-company-config').children('span').data('replace-name-company-id'),
            section_id:$('#user-section-config').children('span').data('replace-name-section-id'),
        };
        _ajax.post(action, datas, function(results) {
            $('.route_search_box').html($(results.route_list_view));
        }
        ,function(xhr, status, errorThrown){
            let responseText = JSON.parse(xhr.responseText);
            toastr.warning(responseText.text);
        });
    });

    // 確定ボタン
    $(document).on('click', '#operation_instructionv2_modal_setting_btn', function() {
        let outward_trip_id = $('.outward_trip-input').data('outward_trip_id');
        let return_trip_id = $('.return_trip-input').data('return_trip_id');

        if(outward_trip_id) {

            let route_master_flg = false;
            if($('meta[name="route"]').attr('content') == 'operation_instructionv2.route_master_setting') {
                route_master_flg = true;
            }

            let action = $(this).data('url');
            let datas = {
                _token: $('meta[name="csrf-token"]').attr('content'),
                outward_trip_id: outward_trip_id,
                return_trip_id: return_trip_id,
                holding_id: $('#user-holding-config').children('span').data('replace-name-holding-id'),
                company_id: $('#user-company-config').children('span').data('replace-name-company-id'),
                section_id: $('#user-section-config').children('span').data('replace-name-section-id'),
                route_master_flg: route_master_flg,
            };

            _ajax.post(action, datas, function(results) {
                zMapMain = $('#instruction_map').find('.video-map');

                RouteData = results.route_list;
                link_data = results.route;

                let $html = $(results.route_list_view);
                $('table.instruction_list tbody').html($html);
                initStartTimePicker($html.find('input.start_time_form'));

                createMap();
                deleteRouteData();
                link_data.forEach(link =>{
                    for (var k=0, l=link.line.latlon.length; k<l; k+=2) {
                        polylineLociLatlon.push(new ZDC.LatLon(String(link.line.latlon[k]),String(link.line.latlon[k+1])));
                    }
                });

                polylineLoci = new ZDC.Polyline(
                    polylineLociLatlon,
                    {
                        strokeColor: '#669DF6',
                        strokeWeight: 3,
                        closePath: false,
                    }
                );
                _zdcMap._zMap.addWidget(polylineLoci);

                let route_name = $('.outward_trip-input').val() +'-'+ $('.return_trip-input').val();
                $('#operation_instruction-text-name').val(route_name);

                let total_time = 0;
                let start_time =  0;
                createMarker(start_time,total_time);
                //drawDirectionRouteData();
                adjustMapZoom();

                if(search_marker) {
                    _zdcMap._zMap.removeWidget(search_marker);
                }
                $('.point_search_box').addClass('d-none');
                $('.add_start_place').addClass('d-none');
                $('.add_waypoint').removeClass('d-none');
                $('.add_start_place').prop('disabled', true);
                $('.add_waypoint').prop('disabled', true);

                if($('#operation_instruction_instruction-submit').length) {
                    $('#operation_instruction_instruction-submit').prop('disabled', false);
                }
                if($('#operation_instruction_route_master-submit').length) {
                    $('#operation_instruction_route_master-submit').prop('disabled', false);
                }
                setPlanData();
                _modal.hide('#select-route-master-modal');
            }
            ,function(xhr, status, errorThrown){
                let responseText = JSON.parse(xhr.responseText);
                toastr.warning(responseText.text);
            });
        } else {
            toastr.warning('経路1は必須です');
        }
    });


    //モーダル閉じるボタン
    $(document).on('click', '#select-route-master-modal .close', function() {
        // 経路マスタからデータを取得しないためにページ上の地図を元に戻す
        $('#select-route-master-modal .modal-content').empty();
        zMapMain = $('#instruction_map').find('.video-map');
        createMap();

        RouteData = $('#instruction_map').find('.video-map').data('route_data');
        link_data = $('#instruction_map').data('link_data');

        deleteRouteData();
        drawDirectionRouteData();
        adjustMapZoom();
    });
}

// 地図を生成
function createMap() {
    let options = {
        addressOfMarker: false,
        zoom: 11,
        mapType: ZDC.MAPTYPE_COLOR,
    };
    if (zMapMain.length > 0) {
        zMapMain.empty();
        //地図を作成
        zMapMain.attr('width', zMapMain.width() + 'px');
        zMapMain.attr('height', zMapMain.height() + 'px');
        if (zMapMain.data('zip_lat') !== '' || zMapMain.data('zip_lon') !== '') {
            options.lat = zMapMain.data('zip_lat');
            options.lon = zMapMain.data('zip_lon');
        }
        _zdcMap.Map.init(zMapMain, options, false);

        /* 地図にイベントを追加 */
        ZDC.addListener(_zdcMap._zMap, ZDC.MAP_CHG_LATLON, onMarkerChangeMap);
        ZDC.addListener(_zdcMap._zMap, ZDC.MAP_CHG_ZOOM, onMarkerChangeMap);
        ZDC.addListener(_zdcMap._zMap, ZDC.MAP_MOUSEMOVE, onMarkerMouseMove);
        ZDC.addListener(_zdcMap._zMap, ZDC.MAP_MOUSEUP, onMarkerMouseUp);

        ZDC.addListener(_zdcMap._zMap, ZDC.MAP_MOUSEMOVE, function() {
            if (dragging) {
                onMarkerMouseMove();
            }
        });

        /* documentにイベントを追加 */
        ZDC.addDomListener(document, 'mouseup', onMarkerMouseUp);
    }
}

//経路データの罫線とマーカを地図上に配置する
function drawRouteData () {
    polylineLoci = false;
    polylineLociLatlon = [];
    if(RouteData.length > 0) {
        //地図上に経路の線を引く
        $.each(RouteData, function(i, item){
            if(item.route_type=='STR' || item.route_type=='END' || item.route_type=='VIA') {
                polylineLociLatlon.push(new ZDC.LatLon(item.latitude, item.longitude));
            }
        });

        polylineLoci = new ZDC.Polyline(
            polylineLociLatlon,
            {
                strokeColor: '#669DF6',
                strokeWeight: 3,
                closePath: false,
            }
        );

        _zdcMap._zMap.addWidget(polylineLoci);

        let n = 0;
        $.each(RouteData, function(i, item){
            if(item.route_type=='STR' || item.route_type=='END' || item.route_type=='VIA') {
                //地図上にマーカーを描く
                marker[n] = new ZDC.Marker(
                    new ZDC.LatLon(item.latitude, item.longitude),
                    {
                        color: ZDC.MARKER_COLOR_ID_GREEN_L,
                    }
                );
                _zdcMap._zMap.addWidget(marker[n]);
                ZDC.addListener(marker[n], ZDC.MARKER_MOUSEMOVE, (function(mrk,n) {
                    return function() {
                        onMarkerMouseMove(mrk);
                    };
                })(marker[n],n))
                ZDC.addListener(marker[n], ZDC.MARKER_MOUSEDOWN, (function(mrk,n) {
                    return function() {
                        mkrLatLon = new ZDC.LatLon($('.operation_instruction-lat').eq(n).val(),$('.operation_instruction-lon').eq(n).val());
                        onMarkerMouseDown(mrk);
                    };
                })(marker[n],n));
                ZDC.addListener(marker[n], ZDC.MARKER_MOUSEUP, (function(n) {
                    return function() {
                        onMarkerMouseUp();
                    };
                })(n));
            }
        });
    }
}

//経路データの罫線とマーカを地図上に配置する
function drawDirectionRouteData (marker_move_flg=true) {
    deleteRouteData();
    polylineLoci = false;
    polylineLociLatlon = [];
    if(link_data.length > 0) {
        //地図上に経路の線を引く
        $.each(link_data, function(i, item){
            polylineLociLatlon.push(new ZDC.LatLon(item.line.latlon[0], item.line.latlon[1]));
            polylineLociLatlon.push(new ZDC.LatLon(item.line.latlon[2], item.line.latlon[3]));
        });
        polylineLoci = new ZDC.Polyline(
            polylineLociLatlon,
            {
                strokeColor: '#669DF6',
                strokeWeight: 3,
                closePath: false,
            }
        );
        _zdcMap._zMap.addWidget(polylineLoci);
    }
    if(RouteData.length > 0) {
        let start_time = 0;
        let total_time = 0;
        //地図上にマーカーを描く
        if($('#operation_instruction-start_time').length) {
            var timeStr = $('#operation_instruction-start_time').val();
            if ($('#operation_instruction-start_time').hasClass('route_master_form')) {
                // ルート検索
                var [hours, minutes] = timeStr.split(':').map(Number);
                start_time = hours*60 + minutes;
            } else {
                // 運行指示書
                dt = new Date($('#operation_instruction-start_time').val());
                start_time =  (dt.getHours()*60) + dt.getMinutes();
            }
        } else if(RouteData[0]) {
            dt = new Date(RouteData[0]['start_time']);
            start_time =  (dt.getHours()*60) + dt.getMinutes();
        } else {
            // ルート検索
            start_time =  9*60; // 09:00で一旦固定
        }
        total_time = 0;
        createMarker(start_time,total_time,marker_move_flg);
    }
}

// 経路データを削除する
function deleteRouteData() {
    if(polylineLoci) {
        _zdcMap._zMap.removeWidget(polylineLoci);
    }
    polylineLoci = false;
    polylineLociLatlon = [];
    if(marker) {
        $.each(marker, function(i, item){
            if(item) {
                _zdcMap._zMap.removeWidget(item);
            }
        });
    }
    marker = [];

    if(msg) {
        $.each(msg, function(i, item){
            if(item) {
                item.close();
                _zdcMap._zMap.removeWidget(item);
            }
        });
    }
    msg = [];

}

// 配置したマーカー、走行軌跡に合わせて地図の中央位置およびズーム倍率を自動調整します。
function adjustMapZoom(){

    let points = [];
    if(marker.length > 0) {
        $.each( Object.values(marker), function ( i, item ) {
            if(item) {
                points.push(item.getLatLon());
            }
        });
    }
    if(msg.length > 0) {
        $.each( Object.values(msg), function ( i, item ) {
            if(item) {
                points.push(item.getLatLon());
            }
        });
    }
    $.each( Object.values(polylineLociLatlon), function ( i, latlon ) {
        points.push(latlon);
    });

    if(points.length > 0){
        let adjusts = _zdcMap._zMap.getAdjustZoom(points);
        if (adjusts) {
            if(adjusts.zoom > 0) {
                adjusts.zoom = adjusts.zoom-1;
            }
            setTimeout(function(){
                _zdcMap._zMap.setZoom(adjusts.zoom);
                _zdcMap._zMap.setHome(new ZDC.LatLon(adjusts.latlon.lat,adjusts.latlon.lon));
                _zdcMap._zMap.moveLatLon(new ZDC.LatLon(adjusts.latlon.lat,adjusts.latlon.lon));
            },100);
        }
    }
}

// マーカーを作成する
function createMarker(start_time, total_time, marker_move_flg=true) {
    let n = 0;
    let marker_num = 0;
    let move_attached_flg = true;
    $.each(RouteData, function(i, item) {
        if(item.route_type != 'RUN' && item.route_type != 'run'
            && item.type != 'RUN' && item.type != 'run') {
            let key  = `MARKER_NUMBER_ID_${n+1}_S`;
            let markerId = ZDC[key];

            const numberImage = createMarkerNumberImage(n+1, {
                width: n >= 10 ? 20 : 18,
                height: 18,
                fontSize: 13,
                backgroundColor: 'rgba(255,255,255,0.0)',
                borderColor: 'rgba(255,255,255,0.0)',
                textColor: '#EEE'
            });

            marker[marker_num] = new ZDC.Marker(
                new ZDC.LatLon(item.latitude, item.longitude),
                {
                    // マーカのサイズに合わせて位置を調整する
                    color:ZDC.MARKER_COLOR_ID_BLUE_S,
                    //number:markerId,
                    custom: {
                        content: {
                            src: numberImage,
                            imgSize: new ZDC.WH(18, 18)
                        }
                    },
                    contentOffset: new ZDC.Pixel(0, 0)
                }
            );
            _zdcMap._zMap.addWidget(marker[marker_num]);

            if(marker_move_flg) {
                if(item.route_type == 'ICI') {
                    move_attached_flg = false;
                } else if(item.route_type == 'ICO') {
                    move_attached_flg = true;
                }
                ////マーカーを移動できるようにする。
                if(item.route_type != 'ICI' && item.route_type != 'ICO' && move_attached_flg) {
                    ZDC.addListener(marker[marker_num], ZDC.MARKER_MOUSEMOVE, (function(mrk) {
                        return function() {
                            onMarkerMouseMove(mrk);
                        };
                    })(marker[marker_num]));

                    ZDC.addListener(marker[marker_num], ZDC.MARKER_MOUSEDOWN, (function(mrk) {
                        return function() {
                            mkrLatLon = mrk.getLatLon();
                            onMarkerMouseDown(mrk);
                        };
                    })(marker[marker_num]));

                    ZDC.addListener(marker[marker_num], ZDC.MARKER_MOUSEUP, (function(mrk, i) {
                        return function() {
                            onMarkerMouseUp();

                            let target_tr = $('table.instruction_list tbody tr').eq(i);

                            let addButton = target_tr.find('.add_button');
                            let raw_ins_num = addButton.data('number');
                            // ボタンがない、または data-number が undefined や null、空文字の場合は処理を中断
                            if (addButton.length === 0 || raw_ins_num === undefined || raw_ins_num === '') {
                                toastr.warning('マーカーのデータが取得できませんでした。時間をおいて再度お試しください');
                                return false;
                            }

                            let ins_num = target_tr.find('.add_button').data('number');
                            let rows = $('table.instruction_list tbody tr');

                            // 動かした地点の内容を引き継ぐためのデータを持っておく
                            let checked = target_tr.find('input.fixed_date_form').prop('checked');
                            let target_date = target_tr.find('input.start_time_form').val();
                            let place_name = target_tr.find('input.place_name_form').val();

                            if(ins_num <= 0) {
                                ins_num = 0;
                            } else {
                                ins_num--;
                            }
                            let route_data = [];

                            let from;
                            let to;
                            let action = $('.add_waypoint').data('url');
                            let datas = [];
                            let mpoints = [];

                            let LatLon = mrk.getLatLon();
                            RouteData[i].latitude = LatLon['lat'];
                            RouteData[i].longitude = LatLon['lon'];

                            let move_attached_flg = true;
                            $.each(RouteData, function(num, item){
                                if(item.route_type == 'ICI') {
                                    move_attached_flg = false;
                                } else if(item.route_type == 'ICO') {
                                    move_attached_flg = true;
                                }
                                let tr = rows.eq(num);
                                item.place_name = tr.find('input.place_name_form').val();
                                if(num==0) {
                                    route_data.push(item);
                                } else if(num==RouteData.length-1){
                                    route_data.push(item);
                                } else {
                                    if(item.work_type != null && move_attached_flg) {
                                        route_data.push(item);
                                    }
                                }
                            });

                            $.each(route_data, function(num, item){
                                if(num==0) {
                                    from = new ZDC.LatLon(item.latitude, item.longitude);
                                } else if(num==route_data.length-1){
                                    to = new ZDC.LatLon(item.latitude, item.longitude);
                                } else {
                                    mpoints.push(item.latitude);
                                    mpoints.push(item.longitude);
                                }
                            });

                            datas = {
                                from_code: from.lat + ',' + from.lon,
                                to_code: to.lat + ',' + to.lon,
                                _token: $('meta[name="csrf-token"]').attr('content'),
                                route_data: route_data,
                                insert_num: ins_num,
                                start_time: $('[name="start_time[0]"]').val(),
                                replaceable_num: $('table.instruction_list tbody tr.replaceable').length
                            };

                            if(mpoints.length > 0) {
                                datas['mpoints'] = mpoints.join(',');
                            }

                            _ajax.post(action, datas, function(results) {
                                deleteRouteData();

                                let resultParse = JSON.parse(results);
                                link_data = resultParse.route;
                                link_data.forEach(link =>{
                                    for (var k=0, l=link.line.latlon.length; k<l; k+=2) {
                                        polylineLociLatlon.push(new ZDC.LatLon(String(link.line.latlon[k]),String(link.line.latlon[k+1])));
                                    }
                                });
                                polylineLoci = new ZDC.Polyline(
                                    polylineLociLatlon,
                                    {
                                        strokeColor: '#669DF6',
                                        strokeWeight: 3,
                                        closePath: false,
                                    }
                                );
                                _zdcMap._zMap.addWidget(polylineLoci);
                                RouteData = resultParse.route_list;

                                let prev = target_tr.prevAll('tr.replaceable').first();
                                let next = target_tr.nextAll('tr.replaceable').first();
                                let targets_row = prev.nextUntil(next);
                                targets_row.remove();

                                let $html = $(resultParse.route_list_view);
                                prev.after($html);
                                initStartTimePicker($html.find('input.start_time_form'));

                                //元データの時間固定がチェックされているなら元に戻す
                                if(checked === true) {
                                    // 移動させた地点の新しいtrを取得
                                    let target = $('table.instruction_list tbody tr.replaceable')
                                    .filter(function () {
                                        let name = $(this).find('input.place_name_form').val();
                                        return name === place_name;
                                    }).first();
                                    target.find('input.start_time_form').val(target_date);
                                    target.find('input.fixed_date_form').prop('checked',true);
                                }

                                renumberInstructionDetail();
                                setDateTime(prev,'run');
                                createMarker(convertStringToTime(prev.find('input.start_time_form').val()),0);

                                $('.point_search_box').addClass('d-none');
                                setPlanData();
                            },function(xhr, status, errorThrown){
                                let responseText = JSON.parse(xhr.responseText);
                                toastr.warning(responseText.text);
                            },'html');
                        }
                    })(marker[marker_num],n));
                }
            }
                marker_num++;
        } else {
            if(item.time3) {
                time3 = parseInt(item.time3);
                start_time += time3;
                total_time += time3;
            }else {
                start_time += ((item.hour * 60) + item.minutes);
                total_time += ((item.hour * 60) + item.minutes);
            }
        }
        n++;
    });
}

// 地図をリサイズする
function resizeMap() {
    let options = {
        addressOfMarker: false,
        zoom: 11,
    };
    if (zMapMain.length > 0) {
        //地図を作成
        zMapMain.attr('width', zMapMain.width() + 'px');
        zMapMain.attr('height', zMapMain.height() + 'px');
        _zdcMap._zMap.refresh();
    }
}

// 日時用の文字列作成
function createDateStr(newTs) {
    var newDt = new Date(newTs);
    var y = newDt.getFullYear();
    var M = pad(newDt.getMonth()+1);
    var d = pad(newDt.getDate());
    var h = pad(newDt.getHours());
    var m = pad(newDt.getMinutes());
    return y + '/' + M + '/' + d + ' ' + h + ':' + m;
}

// 0パディング
function pad(n) {
    return n<10 ? '0'+n : n;
}

/***** マーカー移動関係 *****/

/* マウスダウンイベント処理 */
function onMarkerMouseDown(mrk) {
    /* マウスダウン位置の緯度経度とマーカの緯度経度の差分を保持 */

    var cLatLon = _zdcMap._zMap.getPointerPosition();
    if(mrk) {
        difLat = cLatLon.lat - mkrLatLon.lat;
        difLon = cLatLon.lon - mkrLatLon.lon;
        dragging = true;
        draggingMarker = mrk;
    }
}

/* マウスムーブイベント処理 */
function onMarkerMouseMove(mrk) {
    /* ドラッグ中のみ処理させる */
    if(dragging && draggingMarker) {
        var latlon = _zdcMap._zMap.getPointerPosition();

        /* マーカ表示緯度経度を取得 */
        var mkLat = latlon.lat - difLat;
        var mkLon = latlon.lon - difLon;
        mkrLatLon = new ZDC.LatLon(mkLat, mkLon);
        draggingMarker.moveLatLon(mkrLatLon);

        if(pointerOut()){
            if(timer==null){
                timer = setInterval(movemap, 10);
            }
        }
    }
}

/* マウスアップイベント処理 */
function onMarkerMouseUp() {
    if(dragging) {
        dragging = false;
        draggingMarker = null;
        clearTimer();
    }
}

/* 地図移動時の処理 */
function onMarkerChangeMap() {
    //地図表示領域より20pxくらい小さいBOXを持っておく
    var tl = _zdcMap._zMap.tlToLatLon(ZDC.TL(20 , 20));
    var tr = _zdcMap._zMap.tlToLatLon(ZDC.TL(20 , 730));
    var br = _zdcMap._zMap.tlToLatLon(ZDC.TL(480 , 730));
    var bl = _zdcMap._zMap.tlToLatLon(ZDC.TL(480 , 20));
    llbox = new ZDC.LatLonBox(bl , tr);
}

/* 内枠の内外判定 */
function pointerOut() {
    var point = _zdcMap._zMap.getPointerPosition();

    if(ZDC.isPolygonContainLatLon(point, latlons)){
        clearTimer();
        return false;
    }else{
        if(llbox.getMin().lat > point.lat){
            //下にはみ出た
            direction = 'down';
        }else if(llbox.getMax().lat < point.lat){
            //上にはみ出た
            direction = 'up';
        }else if(llbox.getMin().lon > point.lon){
            //左にはみ出た
            direction = 'left';
        }else if(llbox.getMax().lon < point.lon){
            //右にはみ出た
            direction = 'right';
        }
        return true;
    }
};

function movemap(){
    if(direction == 'down'){
        _zdcMap._zMap.movePx(0,amount);
    }else if(direction == 'up'){
        _zdcMap._zMap.movePx(0,amount*-1);
    }else if(direction == 'left'){
        _zdcMap._zMap.movePx(amount*-1,0 ,0);
    }else if(direction == 'right'){
        _zdcMap._zMap.movePx(amount, 0);
    }
};

function clearTimer(){
    if(timer!=null){
        clearInterval(timer);
        timer=null;
    }
};

// tr要素内のフォーム系のname/idの名前を振りなおす
function renumberInstructionDetail() {
    let place_number = 0;
    $('table.instruction_list tbody tr').each(function(index) {
        $(this).find('td.instruction_number').text(index+1);

        $(this).find('input.start_time_form').attr('id','start_time_'+index);
        $(this).find('input.start_time_form').attr('name','start_time['+index+']');

        $(this).find('input.fixed_date_form').attr('id','fixed_date_'+index);
        $(this).find('input.fixed_date_form').attr('name','fixed_date['+index+']');

        $(this).find('select.work_type_form').attr('id','work_type'+index);
        $(this).find('select.work_type_form').attr('name','work_type['+index+']');

        $(this).find('input.elapsed_time_form').attr('id','elapsed_time_'+index);
        $(this).find('input.elapsed_time_form').attr('name','elapsed_time['+index+']');

        $(this).find('input.place_name_form').attr('id','place_name_'+index);
        $(this).find('input.place_name_form').attr('id','place_name['+index+']');


        if($(this).hasClass('replaceable')) {
            $(this).find('button.add_button').data('number',place_number);
            $(this).find('button.add_button').attr('data-number',place_number);
            $(this).find('button.delete_button').data('number',place_number);
            $(this).find('button.delete_button').attr('data-number',place_number);

            place_number++;
        }
    });
}

function setEditRouteData() {
    // 走行情報を一旦排除
    if (Array.isArray(RouteData)) {
        RouteData = RouteData.filter(function(item) {
            return item && item.type !== 'RUN';
        });
    }


    $('table.instruction_list tbody tr').each(function(index) {
        const tr = $(this);
        if(index in RouteData) {
            if(tr.find('input.start_time_form').length > 0) {
                RouteData[index].start_time = tr.find('input.start_time_form').val();
            } else {
                RouteData[index].start_time = tr.find('div.start_time_box').text();
            }

            if(tr.find('select.work_type_form').length > 0) {
                RouteData[index].work_type = tr.find('select.work_type_form').val();
            }

            if(tr.find('input.elapsed_time_form').length > 0) {
                RouteData[index].time3 = tr.find('input.elapsed_time_form').val();
                RouteData[index].elapsed_time = tr.find('input.elapsed_time_form').val();
            } else {
                RouteData[index].time3 = 0;
                RouteData[index].elapsed_time = 0;
            }

            if(tr.find('input.place_name_form').length > 0) {
                RouteData[index].facility = tr.find('input.place_name_form').val();
            }

            if(tr.find('input.fixed_date_form').prop('checked')) {
                RouteData[index].fixed_date_flg = tr.find('input.fixed_date_form').val();
            } else {
                RouteData[index].fixed_date_flg = 0;
            }

            if(RouteData[index].route_type) {
                RouteData[index].type = RouteData[index].route_type;
            }

            let violation_text = [];
            const raw = $(this).attr('data-warning-messages');
            if (raw) {
                try {
                    violation_text = JSON.parse(raw);
                } catch (e) {
                    console.error(e);
                }
            }

            RouteData[index].violation_text = violation_text;

            if(index > 0) {
                if (RouteData[index].run_data != null && tr.find('input.run_time_form').length > 0) {
                    let runMinutes = parseInt(tr.find('input.run_time_form').val(), 10) || 0;
                    let runStartTime = subtractMinutes(RouteData[index].start_time, runMinutes);

                    RouteData[index].run_data.type = 'RUN';
                    RouteData[index].run_data.facility = null;
                    RouteData[index].run_data.start_time = runStartTime;
                    RouteData[index].run_data.time3 = tr.find('input.run_time_form').val();
                    RouteData[index].run_data.elapsed_time = tr.find('input.run_time_form').val();
                }
            }
        }
    });

    const new_RouteData = [];

    RouteData.forEach(function(item) {
        if (item.run_data != null && item.run_data.length !== 0) {
            new_RouteData.push(item.run_data);
        }

        new_RouteData.push(item);
    });

    RouteData = new_RouteData;
}

function setPlanData() {

    let distance = 0;
    let toll = 0;
    let time = 0;
    let rec_time = 0;
    let run_time = 0;
    let work_time = 0;
    let break_time = 0;
    let rest_time = 0;

    $('.plan_start_place').text($('table.instruction_list tbody tr')
    .first().find('input.place_name_form').val());
    $('.plan_end_place').text($('table.instruction_list tbody tr')
    .last().find('input.place_name_form').val());

    if(RouteData.length > 0) {
        end_data = RouteData.at(-1);
        distance = end_data.distance/1000;
        $.each(RouteData, function(i, item){
            if(item.route_type == 'VIA') {
                if(item.work_type == 1 || item.work_type == 2) {
                    work_time += item.time3;
                    rec_time += item.time3;
                } else if(item.work_type == 4) {
                    break_time += item.time3;
                } else if(item.work_type == 5) {
                    rest_time += item.time3;
                }
            // } else if(item.route_type == 'run' || item.route_type == 'RUN') {
            //     rec_time += item.time3;
            //     run_time += item.time3;
            } else {
                rec_time += item.time3;
                work_time += item.time3;
            }
            if (item.run_data && Object.keys(item.run_data).length > 0) {
                rec_time += item.run_data.time3;
                run_time += item.run_data.time3;
            }
        });
    }

    if(link_data.length > 0) {
        $.each(link_data, function(i, item){
                if(item.toll) {
                toll = toll + item.toll;
            }
        });
    }

    if(distance) {
        $('.plan_mileage').text(distance+'km');
    }
    $('.plan_toll').text(toll+'円');

    $('.elapsed_time_form').each(function(i, item){
        time = time + Number($(item).val());
    });

    $('.run_time_form').each(function(i, item){
        time = time + Number($(item).val());
    });

    $('.plan_time').text(conversionTime(time));

    $('.plan_rec_time').text(conversionTime(rec_time));
    $('.plan_run_time').text(conversionTime(run_time));
    $('.plan_work_time').text(conversionTime(work_time));
    $('.plan_break_time').text(conversionTime(break_time));
    $('.plan_rest_time').text(conversionTime(rest_time));
}

//時間変換(分を時分へ)
function conversionTime(time) {
    time = Math.ceil(time);
    let hour =  Math.floor(time / 60);
    let minute =  time % 60;
    return hour + '時間 ' + minute + '分';

}

function addMinutes(date, minutes) {
    return new Date(date.getTime() + (Number(minutes || 0) * 60 * 1000));
}

function setDateTime(basetr, changedType) {
    let dt = null;

    const baseStartTimeForm = basetr.find('input.start_time_form');
    const baseElapsedTimeForm = basetr.find('input.elapsed_time_form');
    const baseRunTimeForm = basetr.find('input.run_time_form');

    if (changedType === 'run') {
        //移動時間を変更した場合は、前行から再計算する
        const prevTr = basetr.prevAll('tr.route_data_record').first();

        if (prevTr.length > 0) {
            const prevStartTimeForm = prevTr.find('input.start_time_form');
            const prevElapsedTimeForm = prevTr.find('input.elapsed_time_form');

            dt = parseDateTimeLocal(prevStartTimeForm.val());

            if (!dt) {
                return;
            }

            if (prevElapsedTimeForm.length > 0) {
                dt = addMinutes(dt, prevElapsedTimeForm.val());
            }
        } else {
            dt = parseDateTimeLocal(baseStartTimeForm.val());

            if (!dt) {
                return;
            }
        }

        if (baseRunTimeForm.length > 0) {
            dt = addMinutes(dt, baseRunTimeForm.val());
        }

        if (baseStartTimeForm.length > 0) {
            baseStartTimeForm.val(createDateStr(dt));
        }

        if (baseElapsedTimeForm.length > 0) {
            dt = addMinutes(dt, baseElapsedTimeForm.val());
        }
    } else {
        //日付・作業時間を変更した場合、その行の入力値を基準にする
        dt = parseDateTimeLocal(baseStartTimeForm.val());

        if (!dt) {
            return;
        }

        if (baseElapsedTimeForm.length > 0) {
            dt = addMinutes(dt, baseElapsedTimeForm.val());
        }
    }

    // 変更されたフォームと同じ行内のピン止めがチェックされていたら以降のデータを変更しない。
    const isChecked = basetr.find('input[type="checkbox"].fixed_date_form').prop('checked');
    if (isChecked) {
        return false;
    }

    basetr.nextAll('tr.route_data_record').each(function () {
        const tr = $(this);

        const isChecked = tr.find('input[type="checkbox"].fixed_date_form').prop('checked');
        if (isChecked) {
            return false;
        }

        const startTimeForm = tr.find('input.start_time_form');
        const elapsedTimeForm = tr.find('input.elapsed_time_form');
        const runTimeForm = tr.find('input.run_time_form');

        // この行までの移動時間を加算
        if (runTimeForm.length > 0) {
            dt = addMinutes(dt, runTimeForm.val());
        }

        // この行の開始日時を更新
        if (startTimeForm.length > 0) {
            startTimeForm.val(createDateStr(dt));
        }

        // この行の作業時間を加算
        if (elapsedTimeForm.length > 0) {
            dt = addMinutes(dt, elapsedTimeForm.val());
        }
    });
}

function convertStringToTime(dateTime) {
    if (typeof dateTime !== 'string') return 0;

    let m = dateTime.match(/(\d{1,2}):(\d{2})$/);
    if (!m){
         return 0;
    }

    let hours = Number(m[1]);
    let minutes = Number(m[2]);

    return hours * 60 + minutes;
}

function getStartTimeText($tr) {
    let $input = $tr.find('input.start_time_form');
    if ($input.length) {
        return String($input.val() || '').trim();
    }
    let $div = $tr.find('.start_time_box');
    return String($div.text() || '').trim();
}

function getElapsedMinutes($tr) {
    let v = String($tr.find('input.elapsed_time_form').val() || '').trim();
    let n = Number(v);
    return Number.isFinite(n) ? n : NaN;
}

function getRunTimeMinutes($tr) {
    let v = String($tr.find('input.run_time_form').val() || '').trim();
    let n = Number(v);
    return Number.isFinite(n) ? n : NaN;
}

function parseDateTimeLocal(s) {
    if (!s) return null;

    let t = String(s).trim();
    t = t.replace(/\//g, '-');
    t = t.replace(/\s+/, ' ');
    if (t.includes(' ') && !t.includes('T')) t = t.replace(' ', 'T');
    if (/T\d{1,2}:\d{2}$/.test(t)) t += ':00';

    const d = new Date(t);
    return isNaN(d.getTime()) ? null : d;
}

function subtractMinutes(dateTimeStr, minutes) {
    if (!dateTimeStr) return '';

    const normalized = dateTimeStr.replace(/\//g, '-');
    const date = new Date(normalized);

    if (isNaN(date.getTime())) {
        return dateTimeStr;
    }

    date.setMinutes(date.getMinutes() - minutes);

    const y = date.getFullYear();
    const m = String(date.getMonth() + 1).padStart(2, '0');
    const d = String(date.getDate()).padStart(2, '0');
    const h = String(date.getHours()).padStart(2, '0');
    const i = String(date.getMinutes()).padStart(2, '0');

    return `${y}/${m}/${d} ${h}:${i}`;
}

function isDriveRow($tr) {
  // 運転時間 = input.run_time_form がある行
  return $tr.find('input.run_time_form').length >= 0;
}

function getWorkType($tr) {
    return String($tr.find('select.work_type_form').val() || '').trim();
}

function isBreakOrRest($tr) {
    const wt = getWorkType($tr);
    return wt === '4' || wt === '5' || wt==='BRG';
}

function checkContinuousDriveViolations($rows) {
    const DRIVE_LIMIT = 240;
    const BREAK_NEED = 30;
    const BREAK_MIN_EACH = 10;

    let driveMin = 0;
    let breakMin = 0;
    const violations = [];

    $rows.each(function(idx) {
        const $tr = $(this);

        const driveTime = getDriveMinutes($tr);
        const breakTime = getBreakMinutes($tr);

        if (driveTime > 0) {
            if (driveMin < DRIVE_LIMIT && (driveMin + driveTime) > DRIVE_LIMIT) {
            violations.push({
                index: idx,
                $tr,
                reason: '運転累計が4時間を超過（4時間到達前に30分休憩が必要）',
                driveMin: driveMin + driveTime,
                breakMin
            });
            }

            driveMin += driveTime;
        }

        if (isBreakOrRest($tr)) {
            if (breakTime >= BREAK_MIN_EACH) {
                breakMin += breakTime;
                if (breakMin >= BREAK_NEED) {
                driveMin = 0;
                breakMin = 0;
                }
            }
        }
    });

    return { violations };
}

function getDriveMinutes($tr) {
    const v = Number($tr.find('input.run_time_form').val());
    return Number.isFinite(v) ? v : 0;
}

function getBreakMinutes($tr) {
    const workType = String($tr.find('select.work_type_form').val() ?? '');
    if (workType !== '4' && workType !== '5' && workType !== 'BRG') return 0;

    const v = Number($tr.find('input.elapsed_time_form').val());
    return Number.isFinite(v) ? v : 0;
}

function checkDailyDutyOverLimit($rows) {
    const DUTY_LIMIT_MIN = 15 * 60;
    const DAY_BLOCK_MS = 24 * 60 * 60 * 1000;

    const $first = $rows.first();
    const baseText = getStartTimeText($first);
    const baseStart = parseDateTimeLocal(baseText);

    if (!baseStart) {
        return {
            error: '最初の行の start_time_form が日時として解釈できませんでした。',
            dailyDutyMin: new Map(),
            violations: []
        };
    }

    const dailyDutyMin = new Map();
    const violationMap = new Map();

    $rows.each(function(idx) {
        const $tr = $(this);

        const rowStartText = getStartTimeText($tr);
        const rowStart = parseDateTimeLocal(rowStartText);

        if (!rowStart) {
            return;
        }

        const elapsed = Number(getElapsedMinutes($tr)) || 0;
        const runTime = Number(getRunTimeMinutes($tr)) || 0;
        const workType = String($tr.find('.work_type_form').val() || '');

        let totalMin = 0;

        // 休憩・休息は elapsed を含めず runTime のみ
        if (workType === '4' || workType === '5' || workType === 'BRG') {
            totalMin = runTime;
        } else {
            totalMin = elapsed + runTime;
        }

        if (totalMin <= 0) {
            return;
        }

        let segStart = new Date(rowStart.getTime());
        let remainMs = totalMin * 60000;

        while (remainMs > 0) {
            // 最初の開始日時から24時間単位で dayIndex を決める
            const dayIndex = Math.floor(
                (segStart.getTime() - baseStart.getTime()) / DAY_BLOCK_MS
            );

            // 次の日境界
            const nextDayStartMs =
                baseStart.getTime() + (dayIndex + 1) * DAY_BLOCK_MS;

            // 今の24時間枠で使える残り時間
            const availableMsInThisDay = nextDayStartMs - segStart.getTime();

            const chunkMs = Math.min(remainMs, availableMsInThisDay);
            const chunkMin = chunkMs / 60000;

            const beforeMin = dailyDutyMin.get(dayIndex) || 0;
            const afterMin = beforeMin + chunkMin;

            dailyDutyMin.set(dayIndex, afterMin);

            if (beforeMin <= DUTY_LIMIT_MIN && afterMin > DUTY_LIMIT_MIN) {
                const overMin = afterMin - DUTY_LIMIT_MIN;

                if (!violationMap.has(dayIndex)) {
                    violationMap.set(dayIndex, {
                        dayIndex,
                        dutyMin: afterMin,
                        rows: [],
                        rowIndexes: new Set()
                    });
                }

                const violation = violationMap.get(dayIndex);

                if (!violation.rowIndexes.has(idx)) {
                    violation.rowIndexes.add(idx);

                    violation.rows.push({
                        idx,
                        $tr,
                        chunkMin,
                        overMin,
                        beforeMin,
                        afterMin,
                        elapsed,
                        runTime,
                        workType,
                        totalMin,
                        rowStart: new Date(rowStart.getTime())
                    });
                }

                violation.dutyMin = afterMin;
            }

            segStart = new Date(segStart.getTime() + chunkMs);
            remainMs -= chunkMs;
        }
    });

    const violations = Array.from(violationMap.values()).map(v => {
        delete v.rowIndexes;
        return v;
    });

    return { baseStart, dailyDutyMin, violations };
}

function checkOperationTotalOver144h($rows, opts = {}) {
    const LIMIT_MIN = 144 * 60;
    const includeBreakRest = (opts.includeBreakRest ?? true);

    let totalMin = 0;
    const contributingRows = [];

    $rows.each(function(idx){
        const $tr = $(this);
        const elapsed = getElapsedMinutes($tr);
        const runTime = getRunTimeMinutes($tr);

        // 除外オプション
        if (!includeBreakRest && isBreakOrRest($tr)) {
            return;
        }

        totalMin += (elapsed + runTime);
        contributingRows.push({ idx, $tr, elapsed, runTime });
    });

    const isOver = totalMin > LIMIT_MIN;

    return {
        isOver,
        totalMin,
        limitMin: LIMIT_MIN,
        contributingRows
    };
}

function checkDriveTwoDayAverage9h($rows) {
    const LIMIT_AVG_MIN = 9 * 60; // 9h（ちょうどOK → ">"）
    const DAY_BLOCK_MS = 24 * 60 * 60 * 1000;

    const $first = $rows.first();
    const baseText = getStartTimeText($first);
    const baseStart = parseDateTimeLocal(baseText);

    if (!baseStart) {
    return {
        error: '最初の行の start_time が日時として解釈できませんでした（運転2日平均チェック）。',
        violations: []
    };
    }

    let cursor = new Date(baseStart.getTime());

    const driveMinByDay = new Map();
    const driveRowsByDay = new Map();

    $rows.each(function(idx){
    const $tr = $(this);
    const elapsed = getElapsedMinutes($tr);
    const runTime = getRunTimeMinutes($tr);

    const segStart = new Date(cursor.getTime());
    const segEnd   = new Date(cursor.getTime() + (elapsed * 60000) + (runTime * 60000));
    const dayIndex = Math.floor((segStart.getTime() - baseStart.getTime()) / DAY_BLOCK_MS);

    if (isDriveRow($tr)) {
        driveMinByDay.set(dayIndex, (driveMinByDay.get(dayIndex) || 0) + elapsed + runTime);
        if (!driveRowsByDay.has(dayIndex)) driveRowsByDay.set(dayIndex, []);
        driveRowsByDay.get(dayIndex).push({ idx, $tr, elapsed, runTime});
    }

    cursor = segEnd;
    });

    const maxDay = driveMinByDay.size ? Math.max(...Array.from(driveMinByDay.keys())) : 0;
    const getDrive = (d) => (driveMinByDay.get(d) || 0);

    const violations = [];
    for (let dayIndex = 1; dayIndex <= maxDay - 1; dayIndex++) {
    const drivePrev = getDrive(dayIndex - 1);
    const driveCur  = getDrive(dayIndex);
    const driveNext = getDrive(dayIndex + 1);

    const avgPrev = (drivePrev + driveCur) / 2;
    const avgNext = (driveCur + driveNext) / 2;

    if (avgPrev > LIMIT_AVG_MIN && avgNext > LIMIT_AVG_MIN) {
        violations.push({
        dayIndex,
        avgPrevMin: avgPrev,
        avgNextMin: avgNext,
        drivePrevMin: drivePrev,
        driveCurMin: driveCur,
        driveNextMin: driveNext,
        rows: driveRowsByDay.get(dayIndex) || []
        });
    }
    }

    return { baseStart, driveMinByDay, violations };
}

// 既存の警告表示を消す
function clearRowWarnings($rows) {
    $rows.find('.warning_cell span.warning-icon').remove();
    $rows.removeAttr('data-warning-messages');
}

// 行に警告を追加し、メッセージを data 属性に積む
function addRowWarning($tr, message) {
    const current = $tr.attr('data-warning-messages');

    let list = [];
    if (current) {
        try {
            list = JSON.parse(current);
        } catch (e) {
            list = [];
        }
    }

    list.push(message);

    const tooltipText = list.join('\n');
    $tr.attr('data-warning-messages', JSON.stringify(list));

    let $icon = $tr.find('.warning_cell span.warning-icon');

    if ($icon.length === 0) {
        $icon = $('<span class="warning-icon" style="cursor:pointer; color:red;">⚠</span>');
        $tr.find('.warning_cell').append($icon);

        $icon.tooltip({
            title: tooltipText,
            html: false,
            placement: 'top',
            trigger: 'hover focus',
            container: 'body',
            whiteSpace: 'pre-line',
        });
    } else {
        $icon.attr('data-original-title', tooltipText);
    }
}

function applyContinuousDriveWarnings(result) {
  result.violations.forEach(v => {
    addRowWarning(
      v.$tr,
      `【連続運転違反】行${v.index + 1}: ${v.reason}（運転=${v.driveMin}分 / 休憩=${v.breakMin}分）`
    );
  });
}

function applyDailyDutyWarnings(result) {
    if (result.error) return;

    result.violations.forEach(v => {
        const dutyH = (v.dutyMin / 60).toFixed(2);
        v.rows.forEach(r => {
            addRowWarning(
            r.$tr,
            `【拘束時間超過】開始から${v.dayIndex+1}日目の拘束が${dutyH}時間（上限15時間）`
            );
        });
    });
}

function applyOperation144hWarning(opResult, $rows, includeBreakRest) {
    if (!opResult.isOver) return;

    const totalH = (opResult.totalMin / 60).toFixed(2);
    const msg = `【1運行144時間超過】合計${totalH}時間（休憩・休息：${includeBreakRest ? '含む' : '除外'}）`;
    addRowWarning($rows.last(), msg);
}

function applyDriveTwoDayAvgWarnings(result) {
    if (result.error) return;

    result.violations.forEach(v => {
        const a = (v.avgPrevMin / 60).toFixed(2);
        const b = (v.avgNextMin / 60).toFixed(2);
        const msg = `【運転2日平均(9h超)】開始から${v.dayIndex}日目：` +
            `(前日+当日)/2=${a}h, (当日+翌日)/2=${b}h（両方が9h超）`;

        v.rows.forEach(r => addRowWarning(r.$tr, msg));
    });
}

// 違反チェック
function checkRouteData() {
    // 保存時チェック
    const $rows = $('table.instruction_list tbody tr');

    clearRowWarnings($rows);

    const cont = checkContinuousDriveViolations($rows);
    const duty = checkDailyDutyOverLimit($rows);
    const includeBreakRest = true;
    const op = checkOperationTotalOver144h($rows, { includeBreakRest });
    const driveAvg = checkDriveTwoDayAverage9h($rows);

    applyContinuousDriveWarnings(cont);

    if (!duty.error) {
        applyDailyDutyWarnings(duty);
    }

    applyOperation144hWarning(op, $rows, includeBreakRest);

    if (!driveAvg.error) {
        applyDriveTwoDayAvgWarnings(driveAvg);
    }

    return $rows.find('.warning_cell span.warning-icon').length > 0;
}

/* マーカー上に数字を描くための関数 */
function createMarkerNumberImage(num, options) {
    const text = String(num);

    const width = options.width || 24;
    const height = options.height || 18;
    const fontSize = options.fontSize || 14;
    const radius = options.radius || 8;

    const canvas = document.createElement('canvas');
    canvas.width = width;
    canvas.height = height;

    const ctx = canvas.getContext('2d');

    // 背景の角丸
    ctx.beginPath();
    ctx.moveTo(radius, 0);
    ctx.lineTo(width - radius, 0);
    ctx.quadraticCurveTo(width, 0, width, radius);
    ctx.lineTo(width, height - radius);
    ctx.quadraticCurveTo(width, height, width - radius, height);
    ctx.lineTo(radius, height);
    ctx.quadraticCurveTo(0, height, 0, height - radius);
    ctx.lineTo(0, radius);
    ctx.quadraticCurveTo(0, 0, radius, 0);
    ctx.closePath();

    // 背景色
    ctx.fillStyle = options.backgroundColor || 'rgba(255,255,255,0.95)';
    ctx.fill();

    // 枠線
    ctx.lineWidth = options.borderWidth || 1;
    ctx.strokeStyle = options.borderColor || '#333';
    ctx.stroke();

    // 文字
    ctx.fillStyle = options.textColor || '#000';
    ctx.font = `bold ${fontSize}px sans-serif`;
    ctx.textAlign = 'center';
    ctx.textBaseline = 'middle';
    ctx.fillText(text, width / 2, height / 2);

    return canvas.toDataURL('image/png');
}

/** 開始時刻用のフォームにDateTimePickerをセットする */
function initStartTimePicker($target) {
    $target.each(function () {
        const $this = $(this);

        if (!$this.is('input')) {
            return;
        }

        if ($this.data('dtp-initialized')) {
            return;
        }

        const $pickerContainer = $this.closest('.instruction_table_box');
        const displayViewMode = $this.data('display-viewmode') || 'days';
        const minuteStepping = $this.data('minute-stepping') || 1;
        const horizontal = $this.data('horizontal') || 'auto';
        const vertical =  $this.data('vertical') || 'auto';
        const delayDisplay = $this.data('delay-display') || 0;
        const currentValue = $this.val();

        try {
            $this.datetimepicker({
                maxDate: $this.data('max-date') || false,
                minDate: $this.data('min-date') || false,
                format: 'YYYY/MM/DD HH:mm',
                viewMode: displayViewMode,
                stepping: minuteStepping,
                locale: 'ja',
                dayViewHeaderFormat: 'YYYY年 MM月',
                icons: {
                    time: 'far fa-clock'
                },
                defaultViewDate: '2000/05/05 00:00',

                widgetParent: $pickerContainer,

                widgetPositioning: {
                    horizontal: horizontal,
                    vertical: vertical
                }
            });
            $this.data('dtp-initialized', true);
        } catch (error) {
            console.error('DateTimePickerの初期化に失敗しました。', {
                input: $this.get(0),
                pickerContainer: $pickerContainer.get(0),
                containerPosition: $pickerContainer.css('position'),
                error: error
            });
            return;
        }

        $this.val(currentValue);
        $this.off('focus.start_time_form').on('focus.start_time_form', function () {
            const value = $this.val();
            const defaultDate = $this.data('default-date');

            if (value === '' && typeof defaultDate !== 'undefined') {
                $this.val(defaultDate);
            }

            window.setTimeout(function () {
                $this.datetimepicker('show');
                if (value === '') {
                    $this.val('');
                }
            }, delayDisplay);
        });

        $this.off('blur.start_time_form').on('blur.start_time_form', function () {
            const $activeElement = $(document.activeElement);
            const $widget = getDateTimePickerWidget($this);

            if ($widget.length &&
                ($activeElement.closest($widget).length || $widget.is(':hover'))) {
                return;
            }
            $this.datetimepicker('hide');
        });

        $this.off('change.datetimepicker.start_time_form').on('change.datetimepicker.start_time_form',function (e) {
            if (e.oldDate != null &&e.date != null &&!e.oldDate.isSame(e.date)) {
                $this.data('old-timestamp',e.oldDate.unix());
                $this.trigger('change');
            }
        });

        $this.off('show.datetimepicker.start_time_form').on('show.datetimepicker.start_time_form',function () {
            window.requestAnimationFrame(function () {
                positionStartTimePicker(
                    $this,
                    $pickerContainer
                );
            });
        });
    });
}

/**
 * DateTimePicker本体のjQueryオブジェクトを取得する
 */
function getDateTimePickerWidget($input) {
    const picker = $input.data('datetimepicker');
    if (!picker) {
        return $();
    }
    const widget = typeof picker.widget === 'function'? picker.widget(): picker.widget;
    return widget && widget.length? widget: $();
}


/**
 * 開始時刻用DateTimePickerの表示位置を調整する
 */
function positionStartTimePicker($input, $pickerContainer) {
    const $anchor = $input.closest('.start_time_box');
    const $widget = getDateTimePickerWidget($input);

    if (!$pickerContainer.length || !$anchor.length || !$widget.length) {
        return;
    }

    const containerOffset = $pickerContainer.offset();
    const anchorOffset = $anchor.offset();

    if (!containerOffset || !anchorOffset) {
        return;
    }

    const containerWidth = $pickerContainer.innerWidth();
    const widgetWidth = $widget.outerWidth();
    const widgetHeight = $widget.outerHeight();


    let top = anchorOffset.top - containerOffset.top - widgetHeight;
    let left = anchorOffset.left - containerOffset.left;
    let placement = 'top';

    if (top < 0) {
        top = anchorOffset.top - containerOffset.top + $anchor.outerHeight();
        placement = 'bottom';
    }

    const maxLeft = Math.max(0,containerWidth - widgetWidth);
    left = Math.max(0, Math.min(left, maxLeft));

    $widget.removeClass('top bottom').addClass(placement);

    $widget.css({
        position: 'absolute',
        top: top + 'px',
        left: left + 'px',
        right: 'auto',
        bottom: 'auto',
        zIndex: 1500
    });
}

function setDatePickerForStartTime() {
    initStartTimePicker($('input.start_time_form'));
}

// 数字のみ用のinput処理
$(document).on('input', '.number-only', function() {
    const el = this;
    const oldValue = el.value;
    const oldPos = el.selectionStart;

    const beforeCursor = oldValue.slice(0, oldPos);

    const newValue = oldValue
        .replace(/[０-９]/g, s => String.fromCharCode(s.charCodeAt(0) - 65248))
        .replace(/\D/g, '');

    const newBeforeCursor = beforeCursor
        .replace(/[０-９]/g, s => String.fromCharCode(s.charCodeAt(0) - 65248))
        .replace(/\D/g, '');

    if (oldValue !== newValue) {
        el.value = newValue;
        el.setSelectionRange(newBeforeCursor.length, newBeforeCursor.length);
    }
});

// DB上の違反があるデータへの表示
function setViolationIcon(dom_name) {
    $(dom_name).each(function () {
        const $tr = $(this);
        const raw = $tr.attr('data-warning-messages');

        if (!raw) return;

        let messages = [];
        try {
            messages = JSON.parse(raw);
        } catch (e) {
            console.error(e);
            return;
        }

        if (!Array.isArray(messages) || messages.length === 0) {
            return;
        }

        const tooltipText = messages.join('\n');

        let $icon = $tr.find('.warning_cell span.warning-icon');
        if ($icon.length === 0) {
            $icon = $('<span class="warning-icon" style="cursor:pointer; color:red; display:inline-block; white-space:normal;">⚠</span>');
            $tr.find('.warning_cell').append($icon);
        }

        // 既存tooltipがあれば一度破棄
        if ($icon.data('bs.tooltip')) {
            $icon.tooltip('dispose');
        }

        $icon.attr('title', tooltipText).attr('data-original-title', tooltipText);

        $icon.tooltip({
            html: false,
            placement: 'right',
            trigger: 'hover focus',
            container: 'body',
            boundary: 'window'
        });
    });
}

// yyyy/MM/dd HH:mm 形式に整形
function formatDateTime(date) {
    return ('000' + date.getFullYear()).slice(-4) + '/' +
        ('0' + (date.getMonth() + 1)).slice(-2) + '/' +
        ('0' + date.getDate()).slice(-2) + ' ' +
        ('0' + date.getHours()).slice(-2) + ':' +
        ('0' + date.getMinutes()).slice(-2);
}

// 指定日から n 日後の Date を返す
function addDays(date, days) {
    const result = new Date(date.getTime());
    result.setDate(result.getDate() + days);
    return result;
}

// 開始日を基準に終了日を補正
function clampEndDateByStartDate() {
    const $start = $('#operation_instructionv2-operation_start_date');
    const $end = $('#operation_instructionv2-operation_end_date');

    const startDate = parseDateTimeLocal($start.val());
    const endDate = parseDateTimeLocal($end.val());

    if (!startDate || !endDate) {
        return;
    }

    const minEndDate = startDate;
    const maxEndDate = addDays(startDate, 31);

    let fixedEndDate = null;

    // 終了日が開始日より古い場合
    if (endDate.getTime() < minEndDate.getTime()) {
        fixedEndDate = minEndDate;
    }

    // 終了日が開始日+31日より後の場合
    if (endDate.getTime() > maxEndDate.getTime()) {
        fixedEndDate = maxEndDate;
    }

    if (fixedEndDate) {
        $end.val(formatDateTime(fixedEndDate));
    }
}

// 終了日を基準に開始日を補正
function clampStartDateByEndDate() {
    const $start = $('#operation_instructionv2-operation_start_date');
    const $end = $('#operation_instructionv2-operation_end_date');

    const startDate = parseDateTimeLocal($start.val());
    const endDate = parseDateTimeLocal($end.val());

    if (!startDate || !endDate) {
        return;
    }

    const minStartDate = addDays(endDate, -31);
    const maxStartDate = endDate;

    let fixedStartDate = null;

    // 開始日が終了日より新しい場合
    if (startDate.getTime() > maxStartDate.getTime()) {
        fixedStartDate = maxStartDate;
    }

    // 開始日が終了日-31日より古い場合
    if (startDate.getTime() < minStartDate.getTime()) {
        fixedStartDate = minStartDate;
    }

    if (fixedStartDate) {
        $start.val(formatDateTime(fixedStartDate));
    }
}
